import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'silos'
const verb = 'get'

export default class OspreySilosGetById extends BaseAction {
    constructor(dataKey, onError) {
        const id = '4ad5a60c-46dd-4c17-a53e-2d2f99d0ff81'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getById(siloId, params) {
        this.params = params
        this.path = `/${resource}/${siloId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/silos/silos-get-by-id.js